const i18n_detect = {
  EN: [
    { key: 'created_at', label: 'Detect Time' , thStyle: 'width: 10%'},
    { key: 'type', label: 'Type' },
    { key: 'path', label: 'Path'  },
    { key: 'select', label: 'Check' , thStyle: 'width: 30%'}
  ],
  KO : [
    { key: 'created_at', label: '탐지시각' , thStyle: 'width: 10%'},
    { key: 'type', label: '타입', },
    { key: 'path', label: '경로',  },
    { key: 'select', label: '상세' , thStyle: 'width: 30%'}
  ],
  JP: [
    { key: 'created_at', label: '検出時間' , thStyle: 'width: 10%'},
    { key: 'type', label: 'タイプ' },
    { key: 'path', label: 'パス'  },
    { key: 'select', label: 'チェック' , thStyle: 'width: 30%'}
  ]
}

const i18n_result = {
  EN: [
    { key: 'scan_time', label: 'Check Time', thStyle: 'width: 15%'},
    { key: 'scan_folder', label: 'Check Folder', },
    { key: 'scan_count', label: 'Check File', },
    { key: 'detect_count', label: 'Detect Result', },
    { key: 'select', label: 'Check' , thStyle: 'width: 10%'}
  ],
  KO : [
    { key: 'scan_time', label: '점검시간', thStyle: 'width: 15%'},
    { key: 'scan_folder', label: '점검폴더', },
    { key: 'scan_count', label: '점검파일', },
    { key: 'detect_count', label: '탐지결과', },
    { key: 'select', label: '상세' , thStyle: 'width: 10%'}
  ],
  JP: [
    { key: 'scan_time', label: 'チェック時間', thStyle: 'width: 15%'},
    { key: 'scan_folder', label: 'チェックフォルダー', },
    { key: 'scan_count', label: 'チェックファイル', },
    { key: 'detect_count', label: '検出結果', },
    { key: 'select', label: 'チェック' , thStyle: 'width: 10%'}
  ]
}

const i18n_safe = {
  EN: [
    { key: 'created_at', label: 'Detect Time' , thStyle: 'width: 10%', sortable :false},
    { key: 'path', label: 'Path' , thStyle: 'width: 30%', sortable :false},
    // { key: 'hash', label: 'MD5', thStyle: 'width: 20%', sortable :false},
    { key: 'select', label: 'Command' , thStyle: 'width: 20%', sortable :false}
  ],
  KO : [
    { key: 'created_at', label: '탐지시간' , thStyle: 'width: 10%', sortable :false},
    { key: 'path', label: '경로' , thStyle: 'width: 30%', sortable :false},
    // { key: 'hash', label: 'MD5', thStyle: 'width: 20%', sortable :false},
    { key: 'select', label: '명령' , thStyle: 'width: 20%', sortable :false}
  ],
  JP: [
    { key: 'created_at', label: '検出時間' , thStyle: 'width: 10%', sortable :false},
    { key: 'path', label: 'パス' , thStyle: 'width: 30%', sortable :false},
    // { key: 'hash', label: 'MD5', thStyle: 'width: 20%', sortable :false},
    { key: 'select', label: 'コマンド' , thStyle: 'width: 20%', sortable :false}
  ]
}

const i18n_white = {
  EN: [
    { key: 'id', label: 'id' , thStyle: 'width: 30%'},
    { key: 'path', label: 'Path' , thStyle: 'width: 30%'},
    { key: 'select', label: 'Command' , thStyle: 'width: 20%'}
  ],
  KO : [
    { key: 'id', label: 'id' , thStyle: 'width: 30%'},
    { key: 'path', label: '경로' , thStyle: 'width: 30%'},
    { key: 'select', label: '명령' , thStyle: 'width: 20%'}
  ],
  JP: [
    { key: 'id', label: 'id' , thStyle: 'width: 30%'},
    { key: 'path', label: 'パス' , thStyle: 'width: 30%'},
    { key: 'select', label: 'コマンド' , thStyle: 'width: 20%'}
  ]
}

const _i18n_msg = {
  start: {
    EN: `request start`,
    KO: `점검을 요청하였습니다`,
    JP: `リクエスト開始`
  },
  stop: {
    EN: `request stop`,
    KO: `중지를 요청하였습니다`,
    JP: `リクエスト停止`
  }
}

const _i18n_info = {
  ticket_copy : {
    EN: `agent ticket copied for QNA`,
    KO: `agent ticket copied for QNA`,
    JP: `QNA 用にコピーされたエージェントのチケット`
  },
  restore : {
    EN: `file was recovered`,
    KO: `파일이 원복되었습니다`,
    JP: `ファイルが回復されました`
  },
  backup : {
    EN: `file was isolation`,
    KO: `파일이 격리되었습니다`,
    JP: `ファイルは分離されました`
  },
  agent_stop : {
    EN: `agent stopped`,
    KO: `중지되었습니다`,
    JP: `エージェントが停止しました`
  },
  scan_complate : {
    EN: `WSFinder Agent scan complete`,
    KO: `WSFinder Agent scan complete`,
    JP: `WSFinderエージェントのスキャンが完了しました`
  }
}

const _i18n_success = {
  agent: {
    EN: `Request to agents.`,
    KO: `Request to agents.`,
    JP: `エージェントにリクエストします`
  },
  remove : {
    EN: `file was removed`,
    KO: `파일이 삭제되었습니다`,
    JP: `ファイルが削除されました`
  },
  agent_upgrade : {
    EN: `request agent upgrade`,
    KO: `업그레이드를 요청하였습니다`,
    JP: `エージェントのアップグレードをリクエストする`
  },
}

const _i18n_warning = {
  warning : {
    EN: `warning`,
    KO: `warning`,
    JP: `警告`
  },
  folder : {
    EN: `It is not included in the folder1`,
    KO: `It is not included in the folder1`,
    JP: `フォルダー1には含まれていません`
  },
  folder_2 : {
    EN: `It is not included in the folder2`,
    KO: `It is not included in the folder2`,
    JP: `フォルダー2には含まれていません`
  },
  detect_list : {
    EN: `No WebShell detected.`,
    KO: `No WebShell detected.`,
    JP: `WebShellは検出されませんでした`
  },
  setting_white_path : {
    EN: `alert value is not be ZERO`,
    KO: `alert value is not be ZERO`,
    JP: `アラート値がゼロではありません`
  },
  error: {
    EN: `Error`,
    KO: `Error`,
    JP: `エラー`
  },
  download : {
    EN: `Empty File`,
    KO: `Empty File`,
    JP: `空のファイル`
  },
  is_alive : {
    EN: `agent is offline`,
    KO: `agent is offline`,
    JP: `エージェントはオフラインです`
  },
  white_path : { //setting_white_path 같은 이름이라서 변경
    EN: `It's a path that exists.`,
    KO: `It's a path that exists.`,
    JP: `そのバスは存在します`
  }
}

const _i18n_error = {
  setting_rule : {
    EN: `agent ticket copied for QNA`,
    KO: `agent ticket copied for QNA`,
    JP: `QNA 用にコピーされたエージェントのチケット`
  },
  setting_rule_2 : {
    EN: `Please select an application rule first.`,
    KO: `Please select an application rule first.`,
    JP: `最初にアプリケーション ルールを選択してください`
  },
  setting_backup : {
    EN: `Set backup mode.`,
    KO: `Set backup mode.`,
    JP: `バックアップモードを設定します`
  },
  setting_backup_2 : {
    EN: `Please set the Isolation path`,
    KO: `Please set the Isolation path`,
    JP: `分離パスを設定してください`
  },
  setting_backup_3 : {
    EN: `Please select an backup type`,
    KO: `Please select an backup type`,
    JP: `バックアップの種類を選択してください`
  },
  setting_realtime : {
    EN: `Set the real-time monitoring mode.`,
    KO: `Set the real-time monitoring mode.`,
    JP: `リアルタイム監視モードを設定します`
  },
  setting_forgery : {
    EN: `Please set the integrity mode.`,
    KO: `Please set the integrity mode.`,
    JP: `整合性モードを設定してください`
  },
  setting_limit_mode : {
    EN: `check alert condition`,
    KO: `check alert condition`,
    JP: `アラート状態を確認する`
  },
  setting_limit_mode_2 : {
    EN: `alert value is not be ZERO`,
    KO: `alert value is not be ZERO`,
    JP: `アラート値はゼロではありません`
  },
  setting_alive : {
    EN: `Agent Status Check(ERROR)`,
    KO: `Agent Status Check(ERROR)`,
    JP: `エージェントステータスチェック(エラー)`
  },
  setting_rule_3 : {
    EN: `Please select an application rule.`,
    KO: `Please select an application rule.`,
    JP: `アプリケーションルールを選択してください`
  },
  folder_check : {
    EN: `no have scan folder`,
    KO: `no have scan folder`,
    JP: `スキャンフォルダーがありません`
  },
  rule_check : {
    EN: `no have rule for scan`,
    KO: `no have rule for scan`,
    JP: `スキャンのルールはありません`
  },
  agentName_check : {
    EN: `Invalid agent name entered`,
    KO: `Invalid agent name entered`,
    JP: `無効なエージェント名が入力されました`
  },
  res_msg : {
    EN: `white file`,
    KO: `white file`,
    JP: `ホワイトファイル`
  },
  res_msg_2 : {
    EN: `failed`,
    KO: `failed`,
    JP: `失敗しました`
  },
  res_msg_3 : {
    EN: `status failed`,
    KO: `status failed`,
    JP: `ステータスが失敗しました`
  },
  res_msg_4 : {
    EN: `pong failed`,
    KO: `pong failed`,
    JP: `pingが失敗しました`
  },
  res_msg_5 : {
    EN: `resource failed`,
    KO: `resource failed`,
    JP: `リソースが失敗しました`
  },
  result_failed : {
    EN: `result load failed`,
    KO: `result load failed`,
    JP: `結果のロードに失敗しました`
  },
  agent_failed : {
    EN: `agent update failed`,
    KO: `agent update failed`,
    JP: `エージェントの更新に失敗しました`
  },
  agent_failed_2 : {
    EN: `agent delete failed`,
    KO: `agent delete failed`,
    JP: `エージェントの削除に失敗しました`
  },
  refresh_failed : {
    EN: `refresh failed`,
    KO: `refresh failed`,
    JP: `更新に失敗しました`
  },
  agent_update : {
    EN: `the agent updated `,
    KO: `the agent updated `,
    JP: `エージェントが更新されました`
  },
  findout : {
    EN: `find out Webshell`,
    KO: `웹쉘이 탐지 되었습니다`,
    JP: `Webshellを調べる`
  },
  get_path  : {
    EN: `Failed to load path.`,
    KO: `Failed to load path.`,
    JP: `パスの読み込みに失敗しました`
  },
  white_file  : {
    EN: `white file`,
    KO: `white file`,
    JP: `ホワイトファイル`
  },
  download_failed : {
    EN: `download failed`,
    KO: `download failed`,
    JP: `ダウンロードに失敗しました`
  },
  scan_list_check : {
    EN: `Folder Settings Required.`,
    KO: `Folder Settings Required.`,
    JP: `必要なフォルダーを設定`
  }
}

const _i18n_data = {
  i18n_detect,
  i18n_result,
  i18n_safe,
  i18n_white,
  _i18n_msg,
  _i18n_info,
  _i18n_success,
  _i18n_warning,
  _i18n_error,
}

export default _i18n_data